/**
 * List of possible identifier types
 *
 * @namespace tmrIdentifierTypes
 * @type {ngConstant}
 */
export const constant = [
  'tmrIdentifierTypes',
  {
    NFCTag: {
      identifierLabel: 'NFC',
      label: 'NFC',
    },
    UHFTag: {
      identifierLabel: 'UHF',
      label: 'EPC',
    },
    SimpleItemIdentifier: {
      identifierLabel: 'Simple Item',
      label: 'EPC',
    },
    CertilogoIdentifier: {
      identifierLabel: 'Certilogo',
      label: 'Certilogo',
    },
  },
]
